import Avatar from 'funifier-nice-avatar';

import { usePersonFace } from 'components/person-avatar';
import { DestaqueDoFunci } from 'services/destaques.service';

interface AvatarDoFunciProps {
  funci: Pick<DestaqueDoFunci, 'nome' | 'avatar' | 'avatar_type' | 'image'>;
  /** Tamanho da inicial, quando não há foto nem avatar. */
  tamanhoDaInicial?: string;
}

/**
 * Rosto do funci em Destaques: a escolha entre avatar montado, foto e inicial é a do `usePersonFace` (com a volta
 * para o avatar quando a foto não carrega). Decorativo: quem o usa já diz o nome do funci (o cartão no nome
 * acessível, o perfil no título).
 */
export default function AvatarDoFunci({ funci, tamanhoDaInicial = 'text-[26px]' }: AvatarDoFunciProps) {
  const rosto = usePersonFace({ image: funci.image, avatar: funci.avatar, avatarType: funci.avatar_type });

  if (rosto.kind === 'avatar') return <Avatar className="h-full w-full" {...rosto.avatar} />;

  if (rosto.kind === 'photo') {
    return <img src={rosto.url} alt="" onError={rosto.onError} className="h-full w-full object-cover" />;
  }

  return (
    <span
      className={`flex h-full w-full items-center justify-center font-display font-extrabold text-brand-blue-dark ${tamanhoDaInicial}`}
    >
      {funci.nome?.[0]}
    </span>
  );
}
